import { ActionItem } from '../../action-item/entities/action-item.entity';

export enum ActionGroupStyle {
    'Default' = 'sh-action-group',
    'Collapsed' = 'sh-action-group--collapsed'
}

export enum ActionGroupModifier {
    'Condense' = '-sh-condense',
    'Grow' = '-sh-grow-items',
    'End' = '-sh-align-end'
}

export enum ActionGroupItemModifier {
    'ClearRightMargin' = 'sh-clear-margin-right',
    'ClearMargin' = 'sh-clear-margin'
}

export interface ActionGroup {
    readonly actions: ActionItem[];
    readonly style?: ActionGroupStyle;
    readonly modifiers?: ActionGroupModifier[];
    readonly itemModifiers?: ActionGroupItemModifier[];
}
export {};
